import { render, staticRenderFns } from "./list3.vue?vue&type=template&id=34c67cce"
import script from "./list3.vue?vue&type=script&lang=js"
export * from "./list3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports